import { render, staticRenderFns } from "./GridRowLabel.vue?vue&type=template&id=b8299c1a&scoped=true"
import script from "./GridRowLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridRowLabel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GridRowLabel.vue?vue&type=style&index=0&id=b8299c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8299c1a",
  null
  
)

export default component.exports